// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","logo":"XFhKJQbvJvpsxbTdLFde"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/logo/logo.css
// module id = 564
// module chunks = 0